import { composer } from '../../../component-decorators/composer';
import s from '../modals.scss';
import { Modal } from 'wix-style-react';
import * as React from 'react';
import X from 'wix-ui-icons-common/X';
export var NotSupportedInEditorXModal = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var t = _a.t, marketplaceStore = _a.marketplaceStore, appName = _a.appName;
    var handleClose = function () {
        marketplaceStore.closeAllModals();
    };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement("div", { className: s.editorXModalBox },
            React.createElement("div", { className: s.editorXModalCloseWrapper },
                React.createElement("div", { className: s.editorXModalClose, onClick: handleClose },
                    React.createElement(X, null))),
            React.createElement("div", { className: s.editorXModalTitle }, t('modals-notSupportedInEditorX-title', { appName: appName })),
            React.createElement("div", { className: s.editorXModalSubtitle },
                t('modals-notSupportedInEditorX-subtitle1'),
                React.createElement("br", null),
                t('modals-notSupportedInEditorX-subtitle2')),
            React.createElement("div", { className: s.editorXModalCtaWrapper },
                React.createElement("button", { className: s.editorXModalCta, onClick: handleClose }, t('modals-notSupportedInEditorX-cta'))))));
});
//# sourceMappingURL=not-supported-in-editor-x-modal.js.map